export default {
  SITE_URL: "http://localhost:3004",
  SCREENSHOTS_FOLDER: "src/e2e/screenshots",
  LANGUAGES: {
    en: "English",
    ar: "Arabic",
    fr: "Français",
    hi: "Hindi",
    jp: "Japanese",
    ko: "Korean"
  },
  SUBTITLES: {
    en: "English [CC]",
    ar: "Arabic",
    fr: "French",
    hi: "Hindi",
    ta: "Tamil",
    ml: "Malayalam",
    te: "Telugu",
    pa: "Punjabi",
    mr: "Marathi",
    bn: "Bengali",
    bho: "Bhojpuri",
    gu: "Gujrati",
    kn: "Kannada",
    ur: "Urdu"
  }
};
export const RTL = "rtl";
export const STARZPLAYULTIMATE = "starzplayultimate";
